// document.querySelectorAll('p').forEach(p => {
//   if (p.textContent.trim() === '') {
//     p.classList.add('empty');
//   }
// });


document.querySelectorAll('p').forEach(p => {
  if (p.textContent.trim() === '' && p.children.length === 0) {
    p.remove();
  }
});
